import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { EntityService } from '@elotech/angular-common';
import { HttpClient } from '@elotech/angular-common';

@Injectable()
export class ExercicioService extends EntityService<any> {

  constructor(public httpClient: HttpClient) {
    super(httpClient);
    this.resource = '/api/exercicios';
  }

  getNovoExercicio(exercicioValue: number, entidadeId: number): Observable<any> {
    return this.httpClient.get({
      resource: `${this.resource}/${exercicioValue}/${entidadeId}/new`
    });
  }

  verificaSeExercicioComEntidadeJaCadastrado(exercicioValue: number, entidadeId: number) {
    return this.httpClient.get({
      resource: `${this.resource}/exists/${exercicioValue}/${entidadeId}`
    });
  }

  findAllByEntidade(entidadeId: number): Observable<any> {
    return this.httpClient.get({
      resource: `${this.resource}/entidade/${entidadeId}`,
      disableSpinner: true,
      location: this.location
    });
  }

  findAllCompetencias(exercicio: number, entidadeId: number): Observable<any> {
    return this.httpClient.get({
      resource: `${this.resource}/competencias/entidade/${entidadeId}/exercicio/${exercicio}`,
      disableSpinner: true,
      location: this.location
    });
  }
}
